import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentType } from "src/models/HumanResources/DocumentTypes.models";

interface DocumentTypeState {
  documentTypes: IDocumentType[];
  documentTypeToEdit: IDocumentType | null;
}

const initialState: DocumentTypeState = {
  documentTypes: [],
  documentTypeToEdit: null,
};

const DocumentTypeSlice = createSlice({
  name: "DocumentType",
  initialState,
  reducers: {
    setDocumentTypeList: (state, action: PayloadAction<IDocumentType[]>) => {
      state.documentTypes = action.payload;
    },
    concatListDocumentType: (
      state: DocumentTypeState,
      action: PayloadAction<IDocumentType[]>
    ) => {
      state.documentTypes = [...state.documentTypes.concat(action.payload)];
    },
    setDocumentTypeToEdit: (
      state,
      action: PayloadAction<IDocumentType | null>
    ) => {
      state.documentTypeToEdit = action.payload;
    },
    addDocumentType: (state, action: PayloadAction<IDocumentType>) => {
      state.documentTypes.push(action.payload);
    },
    updateDocumentType: (state, action: PayloadAction<IDocumentType>) => {
      let itemIndex = state.documentTypes.findIndex(
        item => item.documentTypeId === action.payload.documentTypeId
      );
      if (itemIndex !== -1) state.documentTypes[itemIndex] = action.payload;
    },
    deleteDocumentType: (state, action: PayloadAction<number>) => {
      const newArray = state.documentTypes.filter(
        item => item.documentTypeId !== action.payload
      );
      state.documentTypes = newArray;
    },
  },
});

export const {
  setDocumentTypeList,
  concatListDocumentType,
  setDocumentTypeToEdit,
  addDocumentType,
  updateDocumentType,
  deleteDocumentType,
} = DocumentTypeSlice.actions;

export default DocumentTypeSlice.reducer;
